import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { EventDetailsModel } from '../../../../providers/event/event';
import { TextValueModel, ValueProvider } from '../../../../providers/value/value';

/**
 * Generated class for the KontaktPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-kontakt',
  templateUrl: 'kontakt.html',
})
export class KontaktPage {

  @Input("eventModel")
  event: EventDetailsModel;

  countries: TextValueModel[] = [];
  constructor(public navCtrl: NavController, public navParams: NavParams, valueService: ValueProvider) {
    valueService.getCountries().then((countries) => {
      this.countries = countries;
      this.event.kontaktCountry = countries[0].value;
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad KontaktPage');
  }
}



// WEBPACK FOOTER //
// /src/pages/event/create/kontakt/kontakt.ts